import { render, staticRenderFns } from "./terms_list.vue?vue&type=template&id=ffe142e8&scoped=true"
import script from "./terms_list.vue?vue&type=script&lang=js"
export * from "./terms_list.vue?vue&type=script&lang=js"
import style0 from "./terms_list.vue?vue&type=style&index=0&id=ffe142e8&prod&lang=css"
import style1 from "./terms_list.vue?vue&type=style&index=1&id=ffe142e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe142e8",
  null
  
)

export default component.exports